// client/src/components/crowdfunding/DocumentUpload.tsx

import React, { useState } from "react";
import { uploadDocument } from "../../services/crowdfundingService";
import "../../assets/styles/crowdfunding.css";

const DocumentUpload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);
    setError(null);
    setMessage(null);

    // Build the payload for the upload.
    const payload = {
      applicationId: "dummy-application-id", // Replace with dynamic application ID from context/props.
      document: file,
    };

    try {
      const response = await uploadDocument(payload);
      console.log("Upload response:", response);
      setMessage("Document uploaded successfully!");
    } catch (err: any) {
      setError(err.message || "Failed to upload document.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="document-upload">
      <h2>Upload Document</h2>
      <input 
        type="file" 
        onChange={handleFileChange} 
        accept=".pdf,.doc,.docx,.jpg,.png" 
      />
      {file && <p>Selected file: {file.name}</p>}
      <button onClick={handleUpload} disabled={!file || uploading}>
        {uploading ? "Uploading..." : "Upload Document"}
      </button>
      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default DocumentUpload;
